import { Reveal } from "./Reveal";

export const SectionHeading = ({ kicker, title, copy, testid }) => (
  <Reveal>
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-blue" data-testid={testid}>
      {kicker}
    </p>
    <div className="mt-4 h-px w-14 bg-blue/60" />
    <h2 className="mt-5 font-display text-2xl font-medium tracking-tight text-cream sm:text-3xl lg:text-4xl">
      {title}
    </h2>
    {copy && <p className="mt-4 max-w-xl text-sm leading-relaxed text-fog sm:text-base">{copy}</p>}
  </Reveal>
);
